import { Cart } from 'hooks/useCart'
import { roundToTwo } from 'utils/formatUtils'
import { ASSEMBLY_FEE, TAX_RATE } from 'constants/pricing'

export const calculatePriceSummary = (
  cart: Cart,
  discountRate = 0,
  discountValid = false
) => {
  const subTotal = roundToTwo(
    cart?.items?.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    ) || 0
  )

  const assemblyFee = roundToTwo(
    cart?.items?.reduce((total, item) => {
      const isExempt = item.afmx === -1
      if (item.isAssembled && item.afmx > 0 && !isExempt) {
        return total + item.afmx * ASSEMBLY_FEE * item.quantity
      }
      return total
    }, 0) || 0
  )

  const totalDiscountAmount = discountValid
    ? roundToTwo((subTotal + assemblyFee) * (discountRate / 100))
    : 0

  const productDiscountAmount = discountValid
    ? roundToTwo(subTotal * (discountRate / 100))
    : 0

  const taxableAmount = roundToTwo(subTotal - productDiscountAmount)

  const tax = cart?.isTaxable ? roundToTwo(taxableAmount * TAX_RATE) : 0

  const totalPrice = roundToTwo(
    subTotal + assemblyFee - totalDiscountAmount + tax
  )

  return {
    subTotal: subTotal.toFixed(2),
    discountedAmount: totalDiscountAmount.toFixed(2),
    tax: tax.toFixed(2),
    assemblyFee: assemblyFee.toFixed(2),
    totalPrice: totalPrice.toFixed(2)
  }
}
